'use client';

import type { SqlEngineStatus } from '@repo/api-gw-sdk';
import React from 'react';

import {
  StatusIcon,
  type StatusConfig,
} from '@/components/lakehouse/statusIcon';

const sqlEngineStatusConfig: Record<string, StatusConfig> = {
  CREATING: {
    title: 'Creating',
    iconColor: 'var(--mui-palette-info-main)',
    backgroundColor: 'var(--mui-palette-info-opacity)',
    icon: 'material-symbols-avg-pace-rounded',
  },
  CREATE_FAILED: {
    title: 'Create Failed',
    iconColor: 'var(--mui-palette-error-main)',
    backgroundColor: 'var(--mui-palette-error-opacity)',
    icon: 'material-symbols-disc-full-outline-rounded',
  },
  STARTING: {
    title: 'Starting',
    iconColor: 'var(--mui-palette-info-main)',
    backgroundColor: 'var(--mui-palette-info-opacity)',
    icon: 'material-symbols-avg-pace-rounded',
  },
  STARTED: {
    title: 'Started',
    iconColor: 'var(--mui-palette-success-main)',
    backgroundColor: 'var(--mui-palette-success-opacity)',
    icon: 'material-symbols-check-circle-outline-rounded',
  },
  STOPPING: {
    title: 'Stopping',
    iconColor: 'var(--mui-palette-info-main)',
    backgroundColor: 'var(--mui-palette-info-opacity)',
    icon: 'material-symbols-avg-pace-rounded',
  },
  STOPPED: {
    title: 'Stopped',
    iconColor: 'var(--mui-palette-custom-GREY-01)',
    backgroundColor: 'var(--mui-palette-custom-GREY-OPACITY)',
    icon: 'material-symbols-do-not-disturb-on-outline-rounded',
  },
  DELETING: {
    title: 'Deleting',
    iconColor: 'var(--mui-palette-info-main)',
    backgroundColor: 'var(--mui-palette-info-opacity)',
    icon: 'material-symbols-avg-pace-rounded',
  },
};

export const SqlEngineStatusCell = React.forwardRef<
  HTMLSpanElement,
  { status: SqlEngineStatus; hideTooltip?: boolean }
>(({ status, hideTooltip }, ref) => (
  <StatusIcon
    ref={ref}
    status={status}
    configMap={sqlEngineStatusConfig}
    hideTooltip={hideTooltip}
  />
));

SqlEngineStatusCell.displayName = 'SqlEngineStatusCell';
